module.exports = __webpack_public_path__ + "img/kos45-03.306d59da.png";